// src/Components/NotificationBell.js
import React, { useEffect, useState } from "react";
import { useNotifications } from "../../APIContext/NotificationContext";
import "./style.css";

function NotificationBell() {
  const { notifications, unreadCount, markAsRead } = useNotifications();
  const [open, setOpen] = useState(false);
  const notification = React.useRef();

  const handleClickOutside = (event) => {
    if (notification.current && !notification.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => setOpen(!open);

  return (
    <div ref={notification} className="notification-wrapper">
      <button className="notification-button" onClick={toggleDropdown}>
        <i className="ri-notification-3-fill notification-bell"></i>
        {unreadCount > 0 && (
          <span className="notification-count">{unreadCount}</span>
        )}
      </button>

      {open && (
        <div className="notification-dropdown">
          {notifications.length === 0 ? (
            <div className="notification-empty">No notifications</div>
          ) : (
            notifications.map((n) => (
              <div
                key={n.id}
                className={`notification-item ${n.is_read ? "read" : "unread"}`}
                onClick={() => markAsRead(n.id)}
              >
                <div className="notification-title text-clip">
                  {n.notification?.title || "Notification"}
                </div>
                <div className="notification-message text-clip">
                  {n.notification?.message || ""}
                </div>
                <div className="notification-time text-clip">
                  {new Date(n.created_at).toLocaleString()}
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}

export default NotificationBell;
